const SUPER_KEY = "IRIS_MANUL_PATROL_";
const USER_NAME = SUPER_KEY + "USER_NAME";
const TOKEN = SUPER_KEY + "TOKEN";
const CURRENT_PATROLER = SUPER_KEY + "PATROL_LIST";

export { USER_NAME, TOKEN, CURRENT_PATROLER };
